import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useSelector } from 'react-redux';
import { selectEstimationTarget } from '../../../selectors/filters';

export const useButtonText = (): string => {
  const estimationTarget: EEstimationTargets = useSelector(selectEstimationTarget);

  switch (estimationTarget) {
    case EEstimationTargets.house:
      return 'Добавить дом';

    case EEstimationTargets.land:
      return 'Добавить участок';

    default:
      return 'Добавить квартиру';
  }
};
